import React,{useState} from 'react'
import { toast } from "react-toastify";
import Cookies from "js-cookie";

const UpdateOrderModal = ({updateHandleChange,selectedRowsData, getData}) => {
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const user_id = Cookies.get("users_id")?.replace(/"/g, "");
    const token = Cookies.get("token")?.replace(/"/g, "");


    const updateData = async (e) => {
        e.preventDefault(); 
        const { id, location, alloted, size, rca_no} = selectedRowsData;
        let BASE_URL = SERVER_URL + `/api/order/orderDetails`;
        const res = await fetch(BASE_URL, {
          method: "PUT",
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id,
            location,
            alloted,
            size,
            rca_no
          }),
        });
        const response = await res.json();
        if (res.ok) {
          console.log(response);
          setTimeout(() => {
            toast.success(response.message);
            // navigate("/dashboard");
          }, 1000);
          getData();
        } else {
          toast.error(response.message);
          getData();
        }
      };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              {/* <h5 class="modal-title" id="imageZoomModalTitle">Galeria</h5> */}
              <button
                type="button"
                class="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Update Order</h4>
                    <form className="form-sample">
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Location">Location</label>
                            <input
                              type="text"
                              className="form-control"
                              name="location"
                              id="Location"
                              value={selectedRowsData.location}
                              placeholder="Location"
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="alloted">Alloted</label>
                            <input
                              type="text"
                              className="form-control"
                              name="alloted"
                              id="alloted"
                              placeholder="Alloted"
                              value={selectedRowsData.alloted}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="rca_no">Rca No</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rca_no"
                              id="rca_no"
                              placeholder="Rca No"
                              value={selectedRowsData.rca_no}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Size">Size</label>
                            <input
                              type="text"
                              className="form-control"
                              name="size"
                              id="size"
                              placeholder="Size"
                              value={selectedRowsData.size}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        onClick={updateData}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UpdateOrderModal